<template lang="pug">
#member_center
  .container
    breadcrumb(v-bind:pageName="pageName")
    p.action_btns
      |
      span.member_info_btn(@click="toMemberEdit") 編輯會員資料
      | |
      span.logout_btn(@click="toLogout") 登出
    .container
  .container.pb-5
    h5.text-center.text-md-left 會員訂單
      span.slash &nbsp;/
      span.notice.text-center.d-lg-none （手機裝置請向右滑動可以看到更多訊息）
    .scroll.mt-3
      .orders_wrapper
        .orders_title.d-flex.justify-content-between.align-items-center
          p.no.head 訂單編號
          p.date.head 報名日期
          p.price.head 付款金額
          p.status.head 訂單狀態
          p.msg.head 留言
          p.qr_code.head 邀請QR碼
          p.print.head 下載繳費單
        li.order_item.d-flex.justify-content-between.align-items-center(
          v-for="(order, index) in orderList",
          :key="index"
        )
          p.no.d-flex.align-items-center(@click="toDetail(order.id)")
            font-awesome-icon(:icon="['fas', 'search']")
            span.ml-1 {{ order.serial_number }}
          p.date {{ formatDate(order.created) }}
          p.price ${{ order.price }}
          p.status(
            :class="{ status_progress: '待處理' == order.state_description || '處理中' == order.state_description, status_unpaid: '待付款' == order.state_description || '查帳中' == order.state_description, status_paid: '已付款' == order.state_description }"
          ) {{ order.state_description }}
          p.msg {{ order.has_new_state ? '新回覆' : '-' }}
          .qr_code(
            v-if="order.group_size > 1 && order.can_create_apply_target",
            @click="showQrcodeDialog(order.id)"
          )
            font-awesome-icon(:icon="['fas', 'qrcode']")
          .qr_code.empty(v-else)
          .print(@click="openBillDialog(order.id)")
            font-awesome-icon(
              v-if="canDownload(order.state_description)",
              :icon="['fas', 'print']"
            )
    b-pagination(
      v-model="currentPage",
      :total-rows="totalRows",
      :per-page="perPage",
      first-number,
      last-number
    ) 
  custom-footer
  dialog-qrcode(:orderID="orderID", :email="userInfo.email")
  bill-dialog(
    v-if="billDialogShow",
    @closeBillDialog="closeBillDialog",
    :orderId="orderId"
  )
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import DialogQrcode from "@/components/member_center/DialogQrcode";
import BillDialog from "@/components/member_center/BillDialog";
import { stopScroll, startScroll } from "@/utils/scroll";
import { mapActions } from "vuex";
import { getOrderList } from "@/api/ecommerce";
import { getUserInfo } from "@/api/user";
import moment from "moment";

export default {
  name: "MemberCenter",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
    DialogQrcode,
    "bill-dialog": BillDialog,
  },
  data() {
    return {
      pageName: "會員專區",
      billDialogShow: false,
      orderList: [],
      orderId: -1,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      orderID: -1,
      userInfo: {},
    };
  },
  watch: {
    currentPage() {
      this.getOrderList();
    },
  },
  created() {
    this.getOrderList();
    this.getUserInfo();
  },
  methods: {
    ...mapActions("user", ["logout"]),
    toLogout() {
      this.logout();
      this.$router.push({ name: "Home" });
    },
    toMemberEdit() {
      this.$router.push({ name: "MemberEdit" });
    },
    getUserInfo() {
      getUserInfo().then((response) => {
        this.userInfo = response.data;
      });
    },
    getOrderList() {
      getOrderList(this.currentPage).then((response) => {
        this.orderList = response.data.results;
        this.totalRows = response.data.count;
      });
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    toDetail(id) {
      this.$router.push({ name: "OrderDetail", query: { id: id } });
    },
    canDownload(state) {
      if ("待處理" == state) {
        return false;
      } else if ("處理中" == state) {
        return false;
      } else if ("待付款" == state) {
        return true;
      } else if ("查帳中" == state) {
        return true;
      } else if ("已付款" == state) {
        return true;
      } else if ("已取消" == state) {
        return false;
      }
    },
    showQrcodeDialog(ID) {
      this.orderID = ID;
      this.$bvModal.show("qrcodeModal");
    },
    openBillDialog(id) {
      this.orderId = id;
      this.billDialogShow = true;
      stopScroll();
    },
    closeBillDialog() {
      this.billDialogShow = false;
      startScroll();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/common/input.scss";
@import "@/assets/style/common/pagination";

#member_center {
  position: relative;
  height: auto;
  position: relative;
}

.container.wrapper {
  min-height: calc(100vh - 80px);
  position: relative;
}

h5 {
  color: $c-text;

  span.slash {
    font-size: 14px;
  }
}

.scroll {
  overflow: scroll;
}

.orders_wrapper {
  width: 100%;
  min-width: 850px;
  height: auto;
  border-radius: 10px 10px 0 0;
  border: 1px solid $color_gray;
  font-size: 14px;

  svg {
    width: 16px;
    height: 16px;
    color: $color_gray;
  }

  p {
    margin: 0;
  }

  .no {
    width: 22%;
    text-align: left;
  }

  .status {
    text-align: center;
    width: 12%;
  }

  .status_paid {
    color: #67c23a;
  }

  .status_progress {
    color: #e6a23c;
  }

  .status_unpaid {
    color: #f56c6c;
  }

  .date {
    width: 16%;
    text-align: center;
  }

  .name {
    width: 15%;
    text-align: center;
  }

  .price {
    width: 12%;
    text-align: center;
    color: $color_dark_blue;
    font-weight: 500;
  }

  .msg {
    width: 80px;
    text-align: center;
  }

  .qr_code {
    width: 80px;
    text-align: center;

    svg {
      color: $c-text;
    }
  }

  .print {
    width: 80px;
    text-align: center;
    svg {
      color: $c-text;
    }
  }

  .head {
    color: $c-text;
  }
}

.orders_title {
  padding: 10px 30px;
  width: 100%;
  height: 48px;
  font-weight: 500;
  font-size: 14px;
  border-bottom: 1px solid #b9bdc7;
}

li.order_item {
  padding: 10px 30px;
  width: 100%;
  height: 60px;

  &:nth-child(odd) {
    background-color: #f5f5f5;
  }

  .no,
  .qr_code,
  .print {
    cursor: pointer;
  }

  .no {
    height: 100%;
  }
}

.container {
  position: relative;
}

.action_btns {
  position: absolute;
  top: 45px;
  right: 15px;
  font-weight: 500;
  font-weight: 20px;
  color: #6d7278;

  .member_info_btn,
  .logout_btn {
    cursor: pointer;
  }

  .member_info_btn {
    color: #6d7278;
    margin-right: 10px;
  }

  .logout_btn {
    color: $color_water_blue;
    margin-left: 10px;
  }
}

@media (max-width: 767px) {
  .breadcrumb-container {
    margin-bottom: 0.5rem;
  }

  .action_btns {
    position: relative;
    top: initial;
    right: initial;
  }
}

@media (max-width: 575px) {
}
</style>
